var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('br'),_vm._v(" "),_c('tickets-table',{attrs:{"site-id":_vm.rowData.id,"read-only":_vm.readOnly,"hide-site":true,"show-owner":true}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }